import RingDialog from '@jetbrains/ring-ui/components/dialog-ng/dialog-ng';
import template from './hub-settings__login.html';

export default angular.module('installer.hub-settings.login', [RingDialog]).
  factory('hubCredentialsFormPopup', ($q, dialog, installerResource) => (message, description, loginAction) => $q((resolve, reject) => dialog.show({
    title: 'Hub credentials',
    template,
    data: {
      message: (message || ''),
      description
    },
    buttons: [
      {
        label: 'OK',
        default: true,
        action(data) {
          return loginAction(data).
            catch(errResponse => {
              const err = installerResource.extractErrorMessage(errResponse.data);
              return $q.reject(err.hubUrl && err.hubUrl.error_description || err);
            }).
            then(resolve);
        }
      },
      {
        label: 'Cancel',
        action() {
          reject({data: 'Authorization was canceled by user'});
        }
      }
    ]
  })));



// WEBPACK FOOTER //
// ./src/pages/hub-settings/hub-settings__login.js